<template>
  <div class="space-y-1">
    <InputLabel :label="label" :is-error="!!seatsError || !!additionalSeatsError">
      <div class="flex gap-2">
        <InputField
          class="min-w-0 flex-1"
          name="seats"
          type="number"
          :min="seatsMin"
          :placeholder="placeholder"
          empty-value-to="null"
        />
        <span class="flex h-8 shrink-0 items-center text-obsidian-500">+</span>
        <InputField
          class="min-w-0 flex-1"
          name="additionalSeats"
          type="number"
          :min="0"
          :placeholder="placeholder"
          empty-value-to="null"
        />
      </div>
    </InputLabel>
    <InputHint v-if="hint" :hint="hint" />
  </div>
</template>

<script setup lang="ts">
import { useField } from 'vee-validate';
import InputField from './InputField.vue';
import InputHint from './InputHint.vue';
import InputLabel from './InputLabel.vue';

defineProps<{
  label: string;
  hint?: string | null;
  placeholder?: string;
  seatsMin?: number;
}>();

const { errorMessage: seatsError } = useField<number | null | undefined>('seats');
const { errorMessage: additionalSeatsError } = useField<number | null | undefined>(
  'additionalSeats',
);
</script>
